import { render, staticRenderFns } from "./TranslationEventsTable.vue?vue&type=template&id=affcd644&"
import script from "./TranslationEventsTable.vue?vue&type=script&lang=js&"
export * from "./TranslationEventsTable.vue?vue&type=script&lang=js&"
import style0 from "./TranslationEventsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VDataTable,VProgressCircular})
